const cleanText = (value) => String(value || '').trim();
const stripListMarker = (value) => value.replace(/^\s*(?:[-*•]|\d+[.)])\s+/, '').trim();

const splitSentences = (text) => {
  if (typeof Intl?.Segmenter === 'function') {
    const segmenter = new Intl.Segmenter('en', { granularity: 'sentence' });
    return [...segmenter.segment(text)].map(({ segment }) => segment.trim()).filter(Boolean);
  }

  return text.match(/[^.!?]+(?:[.!?]+(?=\s|$)|$)/g)?.map((sentence) => sentence.trim()).filter(Boolean) || [];
};

const splitQuestions = (text) => {
  const questions = [];
  let remaining = text;
  let questionMarkIndex = remaining.indexOf('?');

  while (questionMarkIndex >= 0) {
    questions.push(remaining.slice(0, questionMarkIndex + 1).trim());
    remaining = remaining.slice(questionMarkIndex + 1).trim();
    questionMarkIndex = remaining.indexOf('?');
  }

  if (questions.length < 2) return null;

  let introduction = '';
  const firstColonIndex = questions[0].indexOf(':');
  if (firstColonIndex >= 0) {
    introduction = questions[0].slice(0, firstColonIndex + 1).trim();
    questions[0] = questions[0].slice(firstColonIndex + 1).trim();
  }

  return {
    introduction,
    questions: questions.map(stripListMarker).filter(Boolean),
    trailing: remaining,
  };
};

const parseExplicitList = (text) => {
  const lines = text.split('\n').map((line) => line.trim()).filter(Boolean);
  if (lines.length < 2) return null;

  const numbered = lines.every((line) => /^\d+[.)]\s+/.test(line));
  const bulleted = lines.every((line) => /^[-*•]\s+/.test(line));
  if (!numbered && !bulleted) return null;

  return {
    ordered: numbered,
    items: lines.map((line) => line.replace(numbered ? /^\d+[.)]\s+/ : /^[-*•]\s+/, '').trim()),
  };
};

export const formatAnswerForDisplay = (value) => {
  const text = cleanText(value);
  if (!text) return [];

  const explicitList = parseExplicitList(text);
  if (explicitList) return [{ type: explicitList.ordered ? 'numbered-list' : 'bullet-list', items: explicitList.items }];

  const questionList = splitQuestions(text);
  if (questionList) {
    return [
      ...(questionList.introduction ? [{ type: 'paragraph', text: questionList.introduction }] : []),
      { type: 'numbered-list', items: questionList.questions },
      ...(questionList.trailing ? [{ type: 'paragraph', text: questionList.trailing }] : []),
    ];
  }

  const existingParagraphs = text.split(/\n\s*\n/).map((paragraph) => paragraph.trim()).filter(Boolean);
  if (existingParagraphs.length > 1) {
    return existingParagraphs.map((paragraph) => ({ type: 'paragraph', text: paragraph }));
  }

  const sentences = splitSentences(text);
  if (sentences.length <= 3) return [{ type: 'paragraph', text }];

  const paragraphs = [];
  for (let index = 0; index < sentences.length; index += 2) {
    paragraphs.push({ type: 'paragraph', text: sentences.slice(index, index + 2).join(' ') });
  }
  return paragraphs;
};
